import { CancelTokenSource } from 'axios';
import AxiosService from '../utils/axios-service';

export class SearchService extends AxiosService {
  private static instance: SearchService;

  constructor() {
    super('BFF_HELP_CENTER_URL');
  }

  static get getInstance(): SearchService {
    if (!SearchService.instance) {
      SearchService.instance = new SearchService();
    }
    return SearchService.instance;
  }

  public async search(searchTerm: string, source: CancelTokenSource): Promise<any> {
    try {
      const url: string = 'search';
      const response = await this.axios.post(
        url,
        { searchTerm },
        {
          cancelToken: source.token,
        },
      );
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default SearchService.getInstance;
